export default __webpack_public_path__ + "media/hero.8d03bb28d4c4e0d7c1a10a749164da6c.svg";